import { render, staticRenderFns } from "./SSOSetup.vue?vue&type=template&id=016a1c31&scoped=true"
import script from "./SSOSetup.vue?vue&type=script&lang=js"
export * from "./SSOSetup.vue?vue&type=script&lang=js"
import style0 from "./SSOSetup.vue?vue&type=style&index=0&id=016a1c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a1c31",
  null
  
)

export default component.exports